import { render, staticRenderFns } from "./StudyPicture.vue?vue&type=template&id=59da0e52&"
import script from "./studypicture.js?vue&type=script&lang=js&"
export * from "./studypicture.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports